<script setup lang="ts">
import { computed } from "vue";
import { useWindowScroll, useWindowSize } from "@vueuse/core";
import VIcon from "@magnit/icons/src/components/VIcon/VIcon.vue";
import ArrowUpIcon from "@magnit/icons/src/assets/icons/arrow-up-full-24.svg";
import VButton from "../VButton/VButton.vue";
import type { ITopButtonProps } from "./VTopButton.types";

const props = withDefaults(defineProps<ITopButtonProps>(), {
  screenToShow: 2,
  buttonMargin: 68,
});

const { y: scrollY } = useWindowScroll();
const { height: screenHeight } = useWindowSize();

const buttonVisible = computed(
  () =>
    Math.floor((scrollY.value + props.buttonMargin) / screenHeight.value) >=
    props.screenToShow,
);

const onTopClick = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
</script>

<template>
  <Transition name="top-button">
    <VButton
      v-show="buttonVisible"
      theme="invert"
      class="top-button"
      rounded
      @click="onTopClick"
    >
      <template #icon>
        <VIcon>
          <ArrowUpIcon />
        </VIcon>
      </template>
    </VButton>
  </Transition>
</template>

<style scoped lang="postcss">
.top-button-enter-active {
  animation: top-button 0.4s;
}

.top-button-leave-active {
  animation: top-button 0.4s reverse;
}

.top-button {
  position: fixed;
  bottom: var(--pl-unit-x6);
  right: var(--pl-unit-x6);
  z-index: var(--pl-z-index-level3);
  box-shadow:
    0 1px 3px rgb(187 187 187 / 8%),
    0 6px 22px rgb(68 68 68 / 18%);
}

@keyframes top-button {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.25);
  }

  100% {
    transform: scale(1);
  }
}
</style>
